import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "line-echart" }

import { ref, defineComponent, withDefaults, computed } from 'vue'
import BaseEcharts from '@/Base-UI/echarts/index'
import { IDataType } from '../types/index'

export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    xLabels: null,
    values: null
  },
  setup(__props: any) {

const props = __props as {
  title: string
  xLabels: string[]
  values: any[]
}


/* 折线图数据 */
const options = computed(() => {
  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985'
        }
      }
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    legend: {
      data: [props.title]
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: props.xLabels
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: props.title,
        stack: '总量',
        data: props.values,
        type: 'line',
        emphasis: {
          focus: 'servies'
        },
        areaStyle: {}
      }
    ]
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseEcharts), { options: _unref(options) }, null, 8, ["options"])
  ]))
}
}

})